<!-- 견적서 작성 -->
<template>
  <div>
    <admin-box-item title="카테고리 수정" :useTab="false" v-if="value!==undefined">
      <div class="columns is-multiline">
        <div class="column is-full" v-if="!isLaunchpack && !isSpace">
          <admin-form-item label="상품 종류"
            tip="카테고리별로 상품 종류(팩)를 다르게 등록하여 하나의 서비스에서 여러 비즈니스 모델을 운영할 수 있습니다.

                *상품 등록 시, 선택한 상품 종류(팩)의 상품만을 해당 카테고리에 등록할 수 있습니다.">
            <div class="lp-package-button"
                 v-for="pack in selectedPack"
                 :class="{'package-selected':pack.selected===true}"
                 @click="selectPackage(pack)">{{ convertPackName(pack.label) }}</div>
          </admin-form-item>
        </div>
        <div class="column is-7">
          <admin-form-item label="카테고리 명">
            <input class="input"
                   :value="value.name"
                   @input="e => value.name = e.target.value"
                   type="text">
          </admin-form-item>
        </div>

        <div class="column is-7" v-if="!isLaunchpack">
          <admin-form-item label="설명">
            <input class="input"
                   :value="value.desc"
                   @input="e => value.desc = e.target.value"
                   type="text">
          </admin-form-item>
        </div>

        <div class="column is-7" v-if="isLaunchpack">
          <admin-form-item label="배너 설명">
            <textarea class="textarea" rows="10" cols="10" v-model="value.desc"></textarea>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="!isLaunchpack">
          <div class="flex-align">
            <admin-form-item label="기본 이미지" style="margin-bottom:0">
              <input-img :url.sync="value.img_before" :idx="12311112315"></input-img>
            </admin-form-item>
            <admin-form-item label="마우스오버 이미지">
              <input-img :url.sync="value.img_after" :idx="1111235534643"></input-img>
            </admin-form-item>
          </div>
        </div>

        <div class="column is-full" v-if="isLaunchpack">
          <admin-form-item label="이미지">
            <input-img :url.sync="value.img_before" :idx="15754645645564"></input-img>
          </admin-form-item>
        </div>

        <div class="column is-7" v-if="isInternalPlugin('category_filterset') && value.filter_set_id!==0" style="margin-bottom:200px">
          <admin-form-item label="카테고리 필터셋 연동">
            <lp-adm-drop-input :data.sync="filterSet"
                               :selectVal="value.filterName"
                               @onSelect="onSelectFilter"
                               placeholder="카테고리와 매핑시킬 필터셋을 선택하세요."
                               width="100%"
                               listAlign="center"
                               style="width:100%;display:inline-block; margin-right:4px;"></lp-adm-drop-input>
          </admin-form-item>
        </div>


        <div class="column is-full" v-if="enableMeet">
          <admin-form-item label="모임 폼">
            <lp-adm-drop-input :data.sync="meetForm"
                               :selectVal="selectedMeetForm"
                               @onSelect="res => value.meet_form_id = res.value"
                               placeholder="카테고리와 매핑시킬 모임 폼을 선택하세요."
                               width="160px"
                               listAlign="center"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
          </admin-form-item>
        </div>

        <div class="column is-full" v-if="enableCounsel">
          <admin-form-item label="상담 폼">
            <lp-adm-drop-input :data.sync="counselForm"
                               :selectVal="selectedCounselForm"
                               @onSelect="res => value.counsel_form_id = res.value"
                               placeholder="카테고리와 매핑시킬 상담 폼을 선택하세요."
                               width="160px"
                               listAlign="center"
                               style="display:inline-block; margin-right:4px;"></lp-adm-drop-input>
          </admin-form-item>
        </div>

      </div>
      <div class="btn-group-justify-end">
        <button class="button is-light" @click="deleteCat">삭제</button>
        <div class="button is-primary" @click="saveCat">저장하기</div>
      </div>
    </admin-box-item>
    <!-- 카테고리 삭제 모달 -->
    <div class="delete-category-modal">
      <modal name="deleteModal" :adaptive="true" :width="600" height="auto" class="modal-style">
        <div class="lp-modal-wrapper">
          <div style="margin-bottom:28px">
            <div><b>{{ data.label }}</b> 카테고리를 삭제하시겠습니까?</div>
            <div v-if="productCount>0">카테고리에 연결된 {{ productCount }}개의 상품이 있습니다.</div>
            <div v-if="data.children.length>0">{{ data.label }}의 하위 카테고리도 함께 삭제됩니다.</div>
          </div>
          <div class="btn-group-justify-end">
            <button class="button is-light" @click="$modal.hide('deleteModal')">취소</button>
            <button class="button is-primary" @click="confirm">확인</button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import InputImg from "../common/InputImg";
  import LpEditor from "../common/LpEditor";
  import LpAdmDropInput from "../common/LpAdmDropInput";

  export default {
    props: {
      data: {
        type: Object
      },
      isSpace: {
        type: Boolean,
        default: false
      }
    },
    components: {
      LpAdmDropInput,
      LpEditor,
      InputImg,
      AdminFormItem
    },
    data() {
      return {
        value: {

        },
        id: 0,
        packages: [],
        selectedPack: [],
        enableMeet: false,
        enableCounsel: false,
        meetForm: [],
        counselForm: [],
        filterSet: [],
        productCount: 0
      }
    },
    created() {
      this.id = this.data.id;
      this.getCatDetail();

      if(!this.isLaunchpack) {
        let packs = this.$store.getters.getPackages;
        packs = packs.map(item=> {
          return item.name
        })

        if(packs.indexOf('meet')>-1) {
          this.$axios.get('public/meet/form/simple').then(res=> {
            this.meetForm = res.data;
          });
        }
        if(packs.indexOf('counsel')>-1) {
          this.$axios.get('public/counsel/form/simple').then(res=> {
            this.counselForm = res.data;
          });
        }
      }
    },
    computed: {
      selectedMeetForm() {
        let label = '';
        this.meetForm.forEach(item => {
          if (item.value === this.value.meet_form_id) label = item.label;
        });
        return label;
      },
      selectedCounselForm() {
        let label = '';
        this.counselForm.forEach(item=> {
          if(item.value===this.value.counsel_form_id) label = item.label;
        });
        return label;
      }
    },
    watch: {
      data(n) {
        if (n) {
          this.id = n.id;
          this.getCatDetail();
        }
      },
      'value.packages'(n) {
        this.enableMeet = n.indexOf('meet') > -1;
        this.enableCounsel = n.indexOf('counsel') > -1;
      }
    },
    methods: {
      confirm() {
        let url = 'category/'+this.data.id;
        if(this.isSpace) {
          url = 'space/' + url;
        }
        this.$axios.delete(this.getUrl(url))
          .then(res => {
            if(res.status===200) {
              this.$modal.hide('deleteModal');
              this.toast('카테고리가 삭제되었습니다.');
              this.$emit('delete');
            }
          });
      },
      onSelectFilter(res) {
        this.value.filter_set_id = res.value;
      },
      selectPackage(pack){
        // pack (label, selected)
        pack.selected ? pack.selected = false: pack.selected = true;

        // 선택된 상품종류 packages에 담기 ['all', 'estimate', 'call']
        let result = [];
        for(let i=0; i<this.selectedPack.length; i++){
          if(this.selectedPack[i].selected) {
            result.push(this.selectedPack[i].label.name);
          }
        }
        this.value.packages = result;
      },
      // 팩 종류 가져오기
      getPackages(){
        this.$axios.get('public/service/packages').then(res=>{
          this.packages = [{kor_name:'전체', name:'all'}];
          this.packages = this.packages.concat(res.data.filter(i => i.name !== 'space'));
          // 상품종류 ['all', 'estimate', 'call'] => [{label: 'all'}...] 변환
          let result = [];
          for(let i=0; i<this.packages.length; i++){
            result.push({label:this.packages[i], selected: false});
            this.selectedPack = result;
          }

          if(!this.isLaunchpack && this.value.packages.length > 0){
            // 상세에서 패키지 가져온다음 선택된 패키지들 표시
            for(let i=0; i<this.value.packages.length; i++){
              for(let j=0; j<this.selectedPack.length; j++){
                if(this.value.packages[i] === this.selectedPack[j].label.name){
                  this.selectedPack[j].selected = true;
                }
              }
            }
          }
          // 선택한 패키지가 없을 경우
          else {
            if(this.selectedPack.length > 0) this.selectedPack[0].selected = true;
          }
        })
      },
      getCatDetail(){
        this.value = this.data;
        if(!this.isSpace) {
          this.getPackages();
          this.getFilterSet();
        }
        /*this.$axios.get(this.getUrl('category/' + this.id)).then(res=>{
          let value = res.data;
          if(value.meet_form) value.meet_form_id = value.meet_form;
          if(value.counsel_form) value.counsel_form_id = value.counsel_form;
          if(value.estimate_form) value.estimate_form_id = value.estimate_form;

          this.value = value;

          this.getPackages();
          this.getFilterSet();
        })*/
      },
      getFilterSet() {
        if(this.isInternalPlugin('category_filterset')) {
          this.$axios.get('admin/service/set/filter?ordering=id').then(res=>{
            this.filterSet = res.data.map(item => {
              return {
                label: item.name,
                value: item.id
              }
            });
            if(this.value.filter_set_id) {
              let filter = this.filterSet.filter(item=>{return item.value === this.value.filter_set_id });
              if(filter.length>0) {
                filter = filter[0];
              } else {
                filter = this.filterSet[0];
              }
              this.value.filter_set_id = filter.value;
              this.value.filterName = filter.label;
            }
          });
        }
      },
      deleteCat() {
        let url = `user/1/mapping/product?fields=id&category=${this.data.id}`;
        if(this.isSpace) {
          url = `user/1/space/product?fields=id&category=${this.data.id}`
        }
        this.$axios.get(url).then(res=>{
          this.productCount = res.data.count;
          this.$modal.show('deleteModal');
        });
      },
      saveCat() {
        let url = 'category/'+this.value.id;
        if(this.isSpace) {
          url = 'space/' + url;
        }
        this.$store.commit('setLoading', true);
        this.$axios.patch(this.getUrl(url), this.value)
          .then(res => {
            this.$store.commit('setLoading', false);
            this.toast('저장되었습니다.');
            this.value.label = this.value.name;
            this.$emit('update:data', this.value);
            this.$emit('saved');
          }).catch(()=>{
          this.$store.commit('setLoading', false);
          this.toast('저장에 실패했습니다.');
        });
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  .btn-add-category
    padding 12px
    text-align center
    border 1px solid #ff5722
    color #ff5722
    border-radius 4px
    font-size 0.9rem

  .btn-add-category:hover
    color white
    background-color #ff5722
</style>
<style lang="stylus">
  .delete-category-modal
    .v--modal-overlay .v--modal-box
      width 320px !important
      left 50% !important
      transfrom translateX(-50%)
</style>
